export default __webpack_public_path__ + "appointments/static/media/grey.c30fac58.png";